import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ownerApi, inr } from "@/lib/ownerApi";

const fmt = (s) => new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
const KEYS = [["total_income", "Income"], ["collected", "Collected"], ["outstanding_earned", "Outstanding"], ["entitlement", "Salary entitlement"], ["profit", "Profit"], ["yearend_cash", "Year-end cash"]];

export default function Snapshots({ onSaved }) {
  const [rows, setRows] = useState([]);
  const [note, setNote] = useState("");
  const load = useCallback(async () => { const r = await ownerApi.get("/fin/snapshots"); setRows(r.data); }, []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    try { await ownerApi.post("/fin/snapshots", { note }); setNote(""); toast.success("Snapshot saved"); load(); onSaved?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
  };
  return (
    <section className="space-y-2" data-testid="profit-snapshots">
      <h4 className="font-semibold text-stone-800">History of forecast changes</h4>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input placeholder="Note (e.g. after November fees)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="snapshot-note" />
        <Button onClick={save} className="bg-emerald-800 hover:bg-emerald-900" data-testid="snapshot-save">Save snapshot</Button>
      </div>
      <div className="overflow-x-auto rounded-xl border bg-white">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-[11px] uppercase text-stone-500"><tr><th className="px-3 py-2 text-left">When</th>{KEYS.map(([, l]) => <th key={l} className="px-3 py-2 text-right whitespace-nowrap">{l}</th>)}</tr></thead>
          <tbody>
            {rows.map((s, i) => {
              const prev = rows[i + 1]?.summary;
              return (
                <tr key={s.id} className="border-t" data-testid={`snapshot-${i}`}>
                  <td className="px-3 py-1.5 whitespace-nowrap">{fmt(s.at)}<span className="block text-[10px] text-stone-500">{s.note} · {s.by}</span></td>
                  {KEYS.map(([k]) => {
                    const dlt = prev ? s.summary[k] - prev[k] : 0;
                    return <td key={k} className="px-3 text-right whitespace-nowrap">{inr(s.summary[k])}{dlt ? <span className={`block text-[10px] ${dlt > 0 ? "text-emerald-700" : "text-red-700"}`}>{dlt > 0 ? "+" : ""}{inr(dlt)}</span> : null}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
